export default __webpack_public_path__ + "static/media/Icon awesome-database.77ec55d3.svg";